import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionHeader from '../shared/SectionHeader';
import '../../styles/landing/CoupleDashboardSection.css';

const DASHBOARD_CARDS = [
    { key: 'totalGifts', value: '₪48,250' },
    { key: 'activeInstallments', value: '37' },
    { key: 'upcomingPayments', value: '₪6,400' },
    { key: 'blessings', value: '124' },
    { key: 'walletBalance', value: '₪32,900', highlight: true },
] as const;

const CoupleDashboardSection: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section className="landing-section landing-section--cream" aria-labelledby="couple-dashboard-heading">
            <div className="landing-container">
                <SectionHeader
                    title={t('coupleDashboard.title')}
                    subtitle={t('coupleDashboard.subtitle')}
                    id="couple-dashboard-heading"
                />
                <div className="couple-dashboard__grid">
                    {DASHBOARD_CARDS.map((card) => (
                        <article
                            key={card.key}
                            className={`couple-dashboard__card landing-card ${'highlight' in card && card.highlight ? 'couple-dashboard__card--highlight' : ''}`}
                        >
                            <h3 className="landing-card__label">
                                {t(`coupleDashboard.cards.${card.key}`)}
                            </h3>
                            <span className={`landing-card__value ltr-value ${'highlight' in card && card.highlight ? 'landing-card__value--gold' : ''}`}>
                                {card.value}
                            </span>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default CoupleDashboardSection;
